import React, {useContext} from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
  Row,
  UncontrolledTooltip,
  Badge,
  CustomInput,
  Input,
  UncontrolledDropdown, DropdownToggle, DropdownMenu
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import GroupSelect from "../../../elements/groups/GroupSelect";
import ScanbuyTable, {TableColumn} from "../../../tables/ScanbuyTable";
import {RouterLink, useRouterStore} from "mobx-state-router";
import TableActionsDropdown from "../../../tables/TableActionsDropdown";
import * as Icon from "react-feather";
import DeleteState from "../../../codes/delete/DeleteState";
import DeleteView from "../../../codes/delete/DeleteView";
import DeleteRuleSetView from "../delete/DeleteRuleSetView";
import DeleteRuleSetState from "../delete/DeleteRuleSetState";
import GenericModal from "../../../elements/modal/GenericModal";
import {StateContext} from "../../../../App";
import dayjs from "dayjs";
import TagSelect from "../../../elements/tags/TagSelect";
import {
  ADVANCED_SETTINGS_MANAGE_SET,
  formConstants
} from "../../../../utils/constants";
import {createdByColumn, updatedByColumn} from "../../../tables/TableColumns";
import OptionalColumnsDropdown from "../../../elements/dropdown/OptionalColumnsDropdown";
import {getSnapshot} from "mobx-state-tree";
import AdvancedConfFilterSelect from "../../../elements/filters/AdvancedConfFilterSelect";
import CodeOwnerFilterSelect from "../../../elements/filters/CodeOwnerFilterSelect";
import {buildDimensionFilters} from "../../../../utils/buildDimensionFilters";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleDown, faAngleDoubleUp, faSlidersH} from "@fortawesome/free-solid-svg-icons";
import TagFilterSelect from "../../../elements/filters/TagFilterSelect";
import GroupFilterSelect from "../../../elements/filters/GroupFilterSelect";
import {requiredRolesCheck} from "../../../../utils/requiredRolesCheck";
import ResetButton from "../../../ResetButton";
import {buildColumnsWithOptionalSupport} from "../../../../utils/optionalColumnsHelper";



export const buildRuleSetsColumns = (routerStore,ruleSetsListViewState ) => {
  const {rootStore} = routerStore.options;
  const visible = new Set(ruleSetsListViewState.optionalColumns);

  const c1 = TableColumn.create({ name: 'Name', property: 'name', sortable: true, sortField: 'name' });
  c1.setSelector((row)=> {
    return(
      <>
      <span id={`tooltip-${row.uuid}`}>{row.label}</span>
      <UncontrolledTooltip target={`tooltip-${row.uuid}`} placement="top">{row.label}</UncontrolledTooltip>
      </>
    )});

  const c2 = TableColumn.create({
    name: 'Create Date', property: 'created', width: '15%', hide: 'sm',sortable: true, sortField: 'createdAt',
  });
  c2.setSelector((row) => {
    // console.log(row)
    const {createdAt} = row || {};
    const formattedCreateDate = dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedCreateDate;
  });

  const c3 = TableColumn.create({
    name: 'Last Modified', property: 'updated', width: '15%', hide: 'sm', sortable: true, sortField: 'updatedAt',
  });
  c3.setSelector((row) => {
    // console.log(row)
    const { updatedAt } = row || {};
    const formattedUpdateDate = dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedUpdateDate;
  });
  const c4 = TableColumn.create({
    name: 'Tag(s)', property: 'tags', hide: 'sm'
  });
  c4.setSelector((row) => {
    return row.tags;
  });
  c4.setCell((row) => {
    console.log("row",row)
    const tags = row.tags?.flatMap((t) => {
      return {uuid: t.uuid, name: t.name, color: t.uiStyleConfigs?.color || 'info'}
    });
    return (<div>
      {tags?.map((tag, index) => (<Badge
        key={index}
        color="info"
        className="badge-pill mr-1 mb-1"
      >
        {tag.name}
      </Badge>))}
    </div>)
  })

  const createdBy = createdByColumn();
  const updatedBy = updatedByColumn();

  const actionColl = TableColumn.create({
    name: 'Actions', property: 'actions', button: true, allowOverflow: true, ignoreRowClick: true
  });


  actionColl.setCell((row) => (
    <TableActionsDropdown actionsList={[
      <DropdownItem id="action-btn-view" key={'/configs/ruleSets/view/' + row.uuid} onClick={() => {
        routerStore.goTo('editRuleSet', {
          params: { uuid: row.uuid },
          queryParams: {isEditable: 'false'}
        });
      }}><Icon.FileText/>&nbsp;View</DropdownItem>,
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-edit" key={'/configs/ruleSets/edit/' + row.uuid} onClick={() => {
        routerStore.goTo('editRuleSet', {
          params: { uuid: row.uuid },
        });
      }}><Icon.Edit/>&nbsp;Edit</DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-clone" key={'new'} onClick={() => {
        rootStore.rootUiStore.addCloneToCache(`clone-ruleset:${row.uuid}`,row);
        routerStore.goTo('createRuleSet',{
          queryParams: {q: row.uuid}
        })
      }}><Icon.Copy/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.clone.defaultMessage"/>
      </DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-delete" key={row.uuid} value={"Delete " + row.uuid} className="align-text-bottom"
                    onClick={() => {

                      const userRoles = rootStore?.userRoles
                      if(!requiredRolesCheck(ADVANCED_SETTINGS_MANAGE_SET, userRoles)) return

                      const componentStore = DeleteRuleSetState.create(
                        {
                          // codeListStore: codeListViewState,
                          title: `Delete ${row.name ? row.name : ""}`,
                          uuid: row.uuid
                        });
                      rootStore.rootUiStore.attachPageState('deleteRuleSetStore', componentStore)
                      componentStore.setToggleListener(ruleSetsListViewState.modalStore.toggle)
                      componentStore.setRefreshListener(ruleSetsListViewState.refresh)
                      componentStore.setDeleteRuleSetListener(ruleSetsListViewState.listModel.store.removeRules)
                      ruleSetsListViewState.handleRowClick(row, componentStore, DeleteRuleSetView);
                    }}> <Icon.Delete/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.delete.defaultMessage"/>
      </DropdownItem>]: [])


    ]}/>
  ))
  const allColumns = [
    c1,
    c4,
    createdBy,
    updatedBy,
    c2,
    c3,
    actionColl
  ];
  return buildColumnsWithOptionalSupport(allColumns, ruleSetsListViewState, rootStore);
}

const RuleSetsListView = observer(({ruleSetsListViewState}) => {
  const routerStore = useRouterStore();
  const intl = useIntl();
  const stateContext = useContext(StateContext);

  const optionalColumns = stateContext?.appConfigs?.configs?.optional_columns || ['updatedBy'];

  // Get column name mapping from state
  const columnNameMapping = ruleSetsListViewState.columnNameMapping || {};
  console.log("ruleSetsListViewState.columns",ruleSetsListViewState.columns);
  console.log("ruleSetsListViewState.store",ruleSetsListViewState.listModel.getItems());
  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  ruleSetsListViewState.setOnSelectChanges()
  //TODO: PATTERN VIOLATION - Multiple filter setters called on every render (lines 201-205)
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  ruleSetsListViewState?.advFilterSelectState?.setEmails(ruleSetsListViewState.listModel?.filters?.users);
  ruleSetsListViewState?.tagFilterSelectState?.setTags(ruleSetsListViewState.listModel?.filters?.tags);
  ruleSetsListViewState?.filterGroup && ruleSetsListViewState?.groupFilterSelectState?.setGroups(ruleSetsListViewState.listModel?.filters?.groups);
  ruleSetsListViewState?.dimensionSelectViewState?.setFilteredDimensions(ruleSetsListViewState?.listModel?.filters.dimensions);
  ruleSetsListViewState?.loadFiltersFromSessionStorage()

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        color: '#202124',
        fontSize: '14px',
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        // borderRadius: '5px',
        outline: '1px solid #FFFFFF',
      },
    },
    pagination: {
      style: {
        border: 'none',
      },
    },
  }

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col className="d-flex justify-content-end list-view-actions-container">
              {ruleSetsListViewState.isFilterVisible ? (
                <Button
                  id="codelist-dropdown-open"
                  color="primary"
                  onClick={() => ruleSetsListViewState.toggleFilterVisible()}
                >
                  <FontAwesomeIcon icon={faAngleDoubleUp} />
                </Button>
              ) : (
                <Button
                  id="codelist-dropdown-closed"
                  color="primary"
                  onClick={() => ruleSetsListViewState.toggleFilterVisible()}
                >
                  <FontAwesomeIcon icon={faAngleDoubleDown} />
                </Button>
              )}

              <OptionalColumnsDropdown
                listViewState={ruleSetsListViewState}
                buildColumnsFunction={buildRuleSetsColumns}
                idPrefix="rulesets-col"
              />
            </Col>
          </Row>
          {ruleSetsListViewState?.isFilterVisible && <>
            <Row>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "filterByGroups.defaultMessage"})}
                  </InputGroupAddon>
                  {/*<CodeOwnerFilterSelect codeOwnerFilterSelectState={ruleSetsListViewState.codeOwnerFilterSelectState}/>*/}
                  {/*<GroupSelect groupSelectStore={ruleSetsListViewState?.groupSelectStore} multi={true}/>*/}
                  <GroupFilterSelect groupFilterSelectState={ruleSetsListViewState.groupFilterSelectState}/>
                </InputGroup>
              </Col>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                  </InputGroupAddon>
                  <AdvancedConfFilterSelect advFilterSelectState={ruleSetsListViewState.advFilterSelectState}/>
                </InputGroup>
              </Col>
            </Row>
            <Row className="list-view-row-align-end">
              <Col sm={10}>
                <Row>
                  {ruleSetsListViewState?.dimensionSelectViewState?.dimensionsEnabled && ruleSetsListViewState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => buildDimensionFilters(dimensionSelectStore, 6))}
                </Row>
              </Col>
              <ResetButton viewState={ruleSetsListViewState}/>
            </Row>
            <Row>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({id: "listCodes.searchInput.defaultMessage"})}
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="searchInput"
                    placeholder="Search"
                    onChange={ruleSetsListViewState.onSearchChange}
                    value={ruleSetsListViewState.searchTxt}
                  />
                </InputGroup>
              </Col>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    {intl.formatMessage({ id: "listCodes.filterBytags.defaultMessage"})}
                  </InputGroupAddon>
                  {/*<TagSelect tagSelectStore={ruleSetsListViewState?.tagSelectStore}/>*/}
                  <TagFilterSelect tagFilterSelectState={ruleSetsListViewState.tagFilterSelectState}/>
                </InputGroup>
              </Col>
              <Col sm = {1}>
                <CustomInput
                  type="switch"
                  id="isFilterTypeOR"
                  name="isFilterTypeOR"
                  label={formConstants.Mode.OR}
                  checked={ruleSetsListViewState.isFilterTypeOR}
                  onChange={() => ruleSetsListViewState.selectFilterMethod()}
                />
              </Col>
              <Col id="create-ruleset-btn" sm={1} className="justify-content-end text-right" >
                <Button color="primary" onClick={() => {
                  routerStore.goTo('createRuleSet', {});
                }}>
                  <FormattedMessage id="qrDesign.manageList.create.defaultMessage"/>
                </Button>
              </Col>
            </Row>
          </>}
          <Row>
            <Col>
              {/*{ruleSetsListViewState.listModel.store.list.length? <ScanbuyTable*/}
              {/*  columns={ruleSetsListViewState.columns}*/}
              {/*  customStyles={customStyles}*/}
              {/*  store={ruleSetsListViewState.listModel}*/}
              {/*/>:*/}
              <ScanbuyTable
                key={ruleSetsListViewState?.columns.length}
                columns={ruleSetsListViewState.columns}
                customStyles={customStyles}
                store={ruleSetsListViewState.listModel}
                state = {ruleSetsListViewState}
              />
              {/*}*/}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <GenericModal
        modalStore={ruleSetsListViewState.modalStore}
        componentStore={ruleSetsListViewState.modalComponentStore}
        EmbedComponent={ruleSetsListViewState.modalComponent}
      />
    </>
  )
})
export default RuleSetsListView
